import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTrophy, FaMedal, FaGraduationCap, FaFutbol, FaMapMarkerAlt, FaUsers, FaHistory, FaStar, FaHandshake, FaGlobe, FaClock } from 'react-icons/fa';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import bgImage from '../../assets/img/pictures/tttt.jpg';

const Academy = () => {
  const [showModal, setShowModal] = useState(false);

  const ComingSoonModal = () => (
    <AnimatePresence>
      {showModal && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
          onClick={() => setShowModal(false)}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl"
            onClick={e => e.stopPropagation()}
          >
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaClock className="text-2xl text-blue-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Coming Soon!</h3>
              <p className="text-gray-600 mb-6">This feature is currently under development. Stay tuned for updates!</p>
              <button
                onClick={() => setShowModal(false)}
                className="bg-blue-600 text-white px-6 py-2 rounded-full font-semibold hover:bg-blue-700 transition-colors duration-200"
              >
                Got it
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );

  const achievements = [
    { number: "150+", label: "Professional Players", icon: <FaFutbol /> },
    { number: "25+", label: "National Team Players", icon: <FaMedal /> },
    { number: "50+", label: "Youth Championships", icon: <FaTrophy /> },
    { number: "1000+", label: "Academy Graduates", icon: <FaGraduationCap /> }
  ];

  const facilities = [
    {
      title: "Main Training Ground",
      image: require("../../assets/img/pictures/WhatsApp Image 2025-04-03 at 20.01.28_b424bc42.jpg"),
      features: ["4 Full-Size Pitches", "Modern Gym", "Recovery Center"]
    },
    {
      title: "Administration Building",
      image: require("../../assets/img/pictures/WhatsApp Image 2025-04-03 at 20.01.27_a1833af3.jpg"),
      features: ["Office", "Accounts", "Management"]
    },
    {
      title: "Reception",
      image: require("../../assets/img/pictures/WhatsApp Image 2025-04-03 at 20.01.48_780029fd.jpg"),
      features: ["Enquiries", "Visiting", "Customer Service"]
    },
    {
      title: "Class Room",
      image: require("../../assets/img/pictures/WhatsApp Image 2025-04-03 at 20.01.27_80e44ec7.jpg"),
      features: ["Modern Learning Space", "Interactive Teaching", "Study Area"]
    },
    {
      title: "Transport",
      image: require("../../assets/img/pictures/WhatsApp Image 2025-04-03 at 20.01.07_fbb4ff81.jpg"),
      features: ["School Bus Service", "Safe Transportation", "Regular Routes"]
    },
    {
      title: "Volleyball Court",
      image: require("../../assets/img/pictures/WhatsApp Image 2025-04-03 at 20.01.25_46be1408.jpg"),
      features: ["Nutritionist", "Specialized Diets", "Cafeteria"]
    }
  ];

  return (
    <div className="min-h-screen relative">
      <ComingSoonModal />
      {/* Background Pattern */}
      <div className="fixed inset-0 z-0">
        <img
          src={bgImage}
          alt="Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/95 via-blue-900/90 to-black/95"></div>
      </div>

      <div className="relative z-10">
        <Header />

        {/* Main Container Card */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Hero Section */}
          <section className="relative py-8 sm:py-12 md:py-20">
            <div className="container mx-auto">
              <div className="flex flex-col lg:flex-row items-center gap-6 sm:gap-8 lg:gap-12">
                {/* Text Content - Better mobile text sizing */}
                <motion.div 
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8 }}
                  className="lg:w-1/2 text-center lg:text-left w-full"
                >
                  <h1 className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4 md:mb-6">
                    Welcome to Kempshot Sports Academy
                  </h1>
                  <p className="text-base sm:text-lg md:text-xl text-blue-100 mb-6 sm:mb-8">
                    Where champions are made. Established in 2010, we've been nurturing young talent 
                    and shaping the future of football for over a decade.
                  </p>
                  <div className="flex flex-wrap gap-4 justify-center lg:justify-start">
                    <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={() => setShowModal(true)}
                      className="bg-blue-600 text-white px-6 sm:px-8 py-2.5 sm:py-3 rounded-full font-semibold text-sm sm:text-base md:text-lg hover:bg-blue-700 transition-colors duration-200 w-full sm:w-auto"
                    >
                      <FaHistory className="inline-block mr-2" />
                      Our History
                    </motion.button>
                    <motion.button
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      onClick={() => setShowModal(true)}
                      className="bg-white/10 text-white px-6 sm:px-8 py-2.5 sm:py-3 rounded-full font-semibold text-sm sm:text-base md:text-lg hover:bg-white/20 transition-colors duration-200 w-full sm:w-auto"
                    >
                      <FaFutbol className="inline-block mr-2" />
                      Virtual Tour
                    </motion.button>
                  </div>
                </motion.div>

                {/* Featured Image - Responsive sizing */}
                <motion.div
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8 }}
                  className="lg:w-1/2 w-full mt-8 lg:mt-0"
                >
                  <div className="relative rounded-xl sm:rounded-2xl overflow-hidden aspect-[16/9] shadow-[0_8px_30px_rgb(0,0,0,0.12)]">
                    <img 
                      src={require("../../assets/img/pictures/WhatsApp Image 2025-04-03 at 20.01.28_b424bc42.jpg")}
                      alt="Academy Training"
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-tr from-blue-600/40 via-transparent to-black/30" />
                    
                    {/* Quick Stats Overlay - Responsive text */}
                    <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-6 bg-gradient-to-t from-black/80 to-transparent">
                      <div className="flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-0">
                        <div className="flex gap-4 sm:gap-6">
                          <div className="text-white">
                            <div className="text-xl sm:text-2xl font-bold">3</div>
                            <div className="text-xs sm:text-sm text-white/80">Pro Coaches</div>
                          </div>
                          <div className="text-white border-l border-white/20 pl-4 sm:pl-6">
                            <div className="text-xl sm:text-2xl font-bold">2</div>
                            <div className="text-xs sm:text-sm text-white/80">Training Grounds</div>
                          </div>
                        </div>
                        <motion.button
                          whileHover={{ scale: 1.05 }}
                          whileTap={{ scale: 0.95 }}
                          className="bg-white/10 backdrop-blur-sm text-white text-xs sm:text-sm px-4 py-1.5 rounded-full hover:bg-white/20 transition-all duration-200"
                        >
                          View Gallery
                        </motion.button>
                      </div>
                    </div>
                  </div>

                  {/* Floating Badge - Responsive positioning */}
                  <div className="absolute -top-2 sm:-top-4 -right-2 sm:-right-4 bg-blue-600 text-white px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg shadow-lg">
                    <div className="text-xs sm:text-sm font-semibold">FIFA Certified</div>
                    <div className="text-[10px] sm:text-xs opacity-80">Training Center</div>
                  </div>
                </motion.div>
              </div>
            </div>
          </section>

          {/* Achievements Section - Responsive grid */}
          {/* <section className="py-8 sm:py-12 md:py-16">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-6">
                {achievements.map((achievement, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    className="bg-white/10 backdrop-blur-sm rounded-xl p-4 sm:p-6 text-center"
                  >
                    <div className="text-2xl sm:text-3xl text-blue-400 mb-3 sm:mb-4 flex justify-center">
                      {achievement.icon}
                    </div>
                    <div className="text-2xl sm:text-3xl font-bold text-white mb-1 sm:mb-2">{achievement.number}</div>
                    <div className="text-xs sm:text-sm text-blue-100">{achievement.label}</div>
                  </motion.div>
                ))}
              </div>
            </div>
          </section> */}

          {/* Facilities Section - Responsive cards */}
          <section className="py-8 sm:py-12 md:py-16">
            <div className="max-w-7xl mx-auto">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-white mb-8 sm:mb-12">World-Class Facilities</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
                {facilities.map((facility, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    className="bg-white/10 backdrop-blur-sm rounded-xl overflow-hidden"
                  >
                    <div className="relative h-40 sm:h-48">
                      <img 
                        src={facility.image}
                        alt={facility.title}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent">
                        <div className="absolute bottom-4 left-4">
                          <h3 className="text-lg sm:text-xl font-bold text-white">{facility.title}</h3>
                        </div>
                      </div>
                    </div>
                    <div className="p-4 sm:p-6">
                      <ul className="space-y-2">
                        {facility.features.map((feature, i) => (
                          <li key={i} className="flex items-center text-blue-100">
                            <FaStar className="text-blue-400 mr-2 text-xs sm:text-sm" />
                            <span className="text-xs sm:text-sm">{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </section>

          {/* Philosophy Section - Responsive card */}
          <section className="py-8 sm:py-12 md:py-16">
            <div className="max-w-7xl mx-auto">
              <div className="max-w-4xl mx-auto bg-white/10 backdrop-blur-sm rounded-xl sm:rounded-2xl p-6 sm:p-8">
                <h2 className="text-2xl sm:text-3xl font-bold text-center text-white mb-6 sm:mb-8">Our Philosophy</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
                  <div>
                    <h3 className="text-lg sm:text-xl font-semibold text-white mb-3 sm:mb-4 flex items-center">
                      <FaHistory className="mr-2" /> Our Vision
                    </h3>
                    <p className="text-sm sm:text-base text-blue-100">
                      To be the premier football academy in Africa, developing not just skilled players, 
                      but well-rounded individuals who excel both on and off the pitch.
                    </p>
                  </div>
                  <div>
                    <h3 className="text-lg sm:text-xl font-semibold text-white mb-3 sm:mb-4 flex items-center">
                      <FaUsers className="mr-2" /> Our Approach
                    </h3>
                    <p className="text-sm sm:text-base text-blue-100">
                      We believe in holistic development, combining technical skills, tactical understanding, 
                      physical conditioning, and mental strength.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Academy Life Section */}
          <section className="py-16 bg-white/5 backdrop-blur-sm">
            <div className="max-w-7xl mx-auto px-4">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="text-center mb-12"
              >
                <h2 className="text-3xl font-bold text-white mb-4">Academy Life</h2>
                <p className="text-xl text-blue-100 max-w-3xl mx-auto">
                  A structured environment that balances academic excellence with football development
                </p>
              </motion.div>

              {/* Daily Schedule */}
              <div className="grid md:grid-cols-2 gap-8 mb-16">
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6 }}
                  className="bg-white/10 rounded-xl p-6"
                >
                  <h3 className="text-2xl font-bold text-white mb-6">Daily Schedule</h3>
                  <div className="space-y-4">
                    <div className="flex items-start gap-4">
                      <div className="bg-blue-600 text-white px-3 py-1 rounded-lg text-sm font-semibold">6:00 AM</div>
                      <div>
                        <h4 className="text-white font-semibold">Morning Routine</h4>
                        <p className="text-blue-100 text-sm">Wake-up, Morning Stretch, Breakfast, and Personal Hygiene</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="bg-blue-600 text-white px-3 py-1 rounded-lg text-sm font-semibold">8:00 AM</div>
                      <div>
                        <h4 className="text-white font-semibold">Academic Session</h4>
                        <p className="text-blue-100 text-sm">Core and Elective Subjects</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="bg-blue-600 text-white px-3 py-1 rounded-lg text-sm font-semibold">1:00 PM</div>
                      <div>
                        <h4 className="text-white font-semibold">Training Session</h4>
                        <p className="text-blue-100 text-sm">Technical and Tactical Training</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="bg-blue-600 text-white px-3 py-1 rounded-lg text-sm font-semibold">7:00 PM</div>
                      <div>
                        <h4 className="text-white font-semibold">Evening Study</h4>
                        <p className="text-blue-100 text-sm">Study Hall and Academic Support</p>
                      </div>
                    </div>
                  </div>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6 }}
                  className="bg-white/10 rounded-xl p-6"
                >
                  <h3 className="text-2xl font-bold text-white mb-6">Player Development</h3>
                  <div className="space-y-4">
                    <div className="flex items-start gap-4">
                      <div className="bg-green-600 text-white px-3 py-1 rounded-lg text-sm font-semibold">Foundation</div>
                      <div>
                        <h4 className="text-white font-semibold">Every 12 Weeks</h4>
                        <p className="text-blue-100 text-sm">Performance Review and Development Assessment</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="bg-yellow-600 text-white px-3 py-1 rounded-lg text-sm font-semibold">Youth Dev.</div>
                      <div>
                        <h4 className="text-white font-semibold">Every 6 Weeks</h4>
                        <p className="text-blue-100 text-sm">Comprehensive Progress Evaluation</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-4">
                      <div className="bg-red-600 text-white px-3 py-1 rounded-lg text-sm font-semibold">Professional</div>
                      <div>
                        <h4 className="text-white font-semibold">Every 6 Weeks</h4>
                        <p className="text-blue-100 text-sm">Advanced Performance Analysis</p>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>

              {/* Welfare and Support */}
              <div className="grid md:grid-cols-3 gap-8 mb-16">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  className="bg-white/10 rounded-xl p-6"
                >
                  <div className="text-4xl text-blue-400 mb-4">
                    <FaUsers />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-4">Safeguarding</h3>
                  <p className="text-blue-100">
                    Committed to player welfare with clear policies and procedures under our Designated Safeguarding Officer.
                  </p>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  className="bg-white/10 rounded-xl p-6"
                >
                  <div className="text-4xl text-blue-400 mb-4">
                    <FaHandshake />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-4">Open Communication</h3>
                  <p className="text-blue-100">
                    Regular feedback and communication between Academy, players, and parents for continuous improvement.
                  </p>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                  className="bg-white/10 rounded-xl p-6"
                >
                  <div className="text-4xl text-blue-400 mb-4">
                    <FaGlobe />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-4">Excursions</h3>
                  <p className="text-blue-100">
                    Regular educational and recreational excursions throughout the year (additional charges apply).
                  </p>
                </motion.div>
              </div>

              {/* Important Notes */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="bg-white/10 rounded-xl p-8"
              >
                <h3 className="text-2xl font-bold text-white mb-6">Important Information</h3>
                <div className="space-y-6">
                  <div>
                    <h4 className="text-xl font-semibold text-white mb-3">Player Release Policy</h4>
                    <ul className="space-y-2 text-blue-100">
                      <li>• Compensation fees apply for player transfers</li>
                      <li>• Additional contingency fees for players who have appeared in first team matches</li>
                      <li>• Fees determined by football authority based on divisional status</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold text-white mb-3">Complaints Procedure</h4>
                    <ol className="space-y-2 text-blue-100">
                      <li>1. Informal discussion with Academy staff</li>
                      <li>2. Formal written complaint to Academy</li>
                      <li>3. Escalation to GFA if unresolved</li>
                    </ol>
                  </div>
                </div>
              </motion.div>
            </div>
          </section>

          {/* Location Section - Responsive card */}
          <section className="py-8 sm:py-12 md:py-16 bg-blue-600/20 backdrop-blur-sm">
            <div className="max-w-7xl mx-auto text-center">
              <div className="flex items-center justify-center text-white mb-4 sm:mb-6">
                <FaMapMarkerAlt className="text-xl sm:text-2xl mr-2" />
                <h2 className="text-2xl sm:text-3xl font-bold">Visit Our Academy</h2>
              </div>
              <p className="text-lg sm:text-xl text-blue-100 mb-6 sm:mb-8">
                Kempshot School Fiifi Pratt Junction,<br />
                Kasoa Nyanyano Road,<br />
                Central Region, Ghana
              </p>
              <motion.a
                href="https://maps.app.goo.gl/JioxYuaTTetYXSDU7"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="inline-block bg-white text-blue-600 px-6 sm:px-8 py-2.5 sm:py-3 rounded-full font-semibold text-sm sm:text-base hover:bg-blue-50 transition-colors duration-200"
              >
                Get Directions
              </motion.a>
            </div>
          </section>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default Academy; 